import React, { ReactElement } from 'react';
import './index.css';

export interface StickyProps {
  children: JSX.Element | JSX.Element[];
}

export const StickyHeader = (props: StickyProps): ReactElement => {
  const { children } = props;
  return <div className="sticky-header ">{children}</div>;
};

export const StickyBody = (props: StickyProps): ReactElement => {
  const { children } = props;
  return <div className="sticky-content">{children}</div>;
};

export const Sticky = (props: StickyProps): ReactElement => {
  const { children } = props;
  return (
    <div className="sticky-container">
      {children}
    </div>
  );
};

export default Sticky;
